import { Component } from 'react';
import { withRouter } from 'react-router';
import PropTypes from 'prop-types';

class ScrollToTop extends Component {

  componentDidUpdate(prevProps) {
    let mylocation=window.location;
    if(navigator.userAgent.match(/Android/i)) {
        mylocation=document.location;      
    }

      
      if (mylocation.toString().indexOf("#") === -1){      
          if (this.props.location !== prevProps.location) {
              window.scrollTo(0, 0);
//              let mylocation=window.location;
              //window.alert('location: '+window.location);
            //  if (mylocation.toString().indexOf("profile") === -1 && mylocation.toString().indexOf("/magazine/subscribe") === -1 && mylocation.toString().indexOf("newsletters") === -1 && mylocation.toString().indexOf("login") === -1 && mylocation.toString().indexOf("forgot-password") === -1 && mylocation.toString().indexOf("Welcome%20to%20Selling%20Power") === -1 ){
            //      if(navigator.userAgent.match(/Android/i)) {              
             //       document.location = mylocation;
               //   } else {
              //      window.location.reload();          
               //   }
//
            //  }
          }
	  
      }
  }

  render() {
    return this.props.children
  }
}

ScrollToTop.propTypes = {
  location: PropTypes.object.isRequired
}

export default withRouter(ScrollToTop);



// WEBPACK FOOTER //
// ./src/components/scroll-to-top/index.js